import { render, staticRenderFns } from "./inProgress.vue?vue&type=template&id=589f21e5&"
import script from "./inProgress.vue?vue&type=script&lang=ts&"
export * from "./inProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports